export default __webpack_public_path__ + "static/AirForceDevice-2cdebff5f0164ec5c0db2cabf119938f.jpg";